import React from 'react'

import PrimaryHeader from '../../../components/primary-header'
import Title from '../../../components/title'
import Icon from '../../../components/icon'
import Map from '../../../components/map'

import * as S from './styles'

import IProps from './props'

import LinkBuilder from '../../../helpers/helper-link-builder'

import userIMG from '../../../assets/png/user-profile.png'

const Contractor = ({
  contractor,
  handleOpenChat,
  handleContract,
  location,
  isContracted,
}: IProps) => (
  <S.Container>
    <PrimaryHeader>
      <Title>Voltar</Title>
      <S.InfoContainer>
        <S.Image
          src={
            contractor.imgUrl
              ? LinkBuilder.buildAssetsUrl(contractor.imgUrl)
              : userIMG
          }
        />
        <S.InfoDetailsContainer>
          <S.InfoTitle>{contractor.corporateName}</S.InfoTitle>
          <S.Info>
            <Icon name="email" />
            <a
              href={LinkBuilder.buildMailtoLink(contractor.email)}
              target="_blank"
              rel="noreferrer"
              data-class="email"
            >
              {contractor.email}
            </a>
          </S.Info>
          <S.Info>
            <Icon name="whatsapp" />
            <a
              href={LinkBuilder.buildWhatsAppLink(contractor.phone)}
              rel="noreferrer"
              target="_blank"
            >
              {contractor.phone}
            </a>
            <Icon name="arrow-right-second" data-name="arrow-right-second" />
          </S.Info>
          <S.Info onClick={handleOpenChat}>
            <Icon name="message" />
            Conversar pelo chat
          </S.Info>
        </S.InfoDetailsContainer>
      </S.InfoContainer>
      {!isContracted && (
        <>
          <S.TextHeader>
            Caso tenha sido contratado(a) por esta instituição, nos informe
            clicando no botão abaixo:
          </S.TextHeader>
          <S.ConfirmButton invertColor onClick={handleContract}>
            Esta instituição me contratou
          </S.ConfirmButton>
        </>
      )}
    </PrimaryHeader>
    <S.Content>
      <S.ContentDetails>
        <S.DetailTitle>Tipo de instituição</S.DetailTitle>
        <S.DetailText>{contractor.institutionType}</S.DetailText>
      </S.ContentDetails>
      <S.ContentDetails>
        <S.DetailTitle>Sobre</S.DetailTitle>
        <S.DetailText>{contractor.about}</S.DetailText>
      </S.ContentDetails>
      <S.ContentDetails>
        <S.DetailTitle>Endereço</S.DetailTitle>
        <S.DetailText>{`${contractor.address.street}, ${contractor.address.number}.`}</S.DetailText>
        <S.DetailText>
          {`${contractor.address.neighborhood} - ${contractor.address.city}/${contractor.address.state}`}
        </S.DetailText>
        <Map location={location} />
      </S.ContentDetails>
      <S.ContentDetails>
        <S.DetailTitle>Observações</S.DetailTitle>
        <S.DetailText>{contractor.observation}</S.DetailText>
      </S.ContentDetails>
      {/* <S.ContentDetails>
        <S.DetailTitle>Especialidades</S.DetailTitle>
        <S.DetailText>{contractor.specialties.join(', ')}</S.DetailText>
      </S.ContentDetails> */}
      <S.ContentDetails>
        <S.DetailTitle>Disponibilidade</S.DetailTitle>
        <S.DetailText>{contractor.availability.join(', ')}</S.DetailText>
      </S.ContentDetails>
      <S.ContentDetails>
        <S.DetailTitle>Site da instituição</S.DetailTitle>
        <S.DetailText>{contractor.site}</S.DetailText>
      </S.ContentDetails>
      {!isContracted && (
        <>
          <S.TextContent>
            <span>Caso tenha sido contratado(a) por esta instituição,</span>
            {' '}
            nos
            informe clicando no botão abaixo:
          </S.TextContent>
          <S.ConfirmButton onClick={handleContract}>
            Esta instituição me contratou
          </S.ConfirmButton>
        </>
      )}
    </S.Content>
  </S.Container>
)

export default Contractor
